export const HOME = '/';
export const SIGNIN = '/signin';
export const ADMIN = '/admin';
export const SIGNUP = '/signup';
export const PROFIL = '/profil';
export const INFO = '/info';
export const RESETPASSWORD = '/reset';
export const ISVERIFIED = '/isverified';